export default {
  data () {
    return {
      DELETE_SEGMENT_MESSAGE: 'このセグメントを削除します',
      DELETE_SITE_MESSAGE: 'この計測対象を削除します',
      DELETE_JOB_MESSAGE: 'このジョブを削除します',
    }
  },
}
